export default __webpack_public_path__ + "static/media/check 2 3.108e5594.svg";